document.addEventListener('DOMContentLoaded', () => {
  const moveWishlist = () => {
    const wishlist = document.querySelector(
      '.inkhub-wishlist-heart'
    );
    const gallery = document.querySelector(
      '.product__media-gallery-viewer-wrap'
    );

    if (!wishlist || !gallery || gallery.contains(wishlist)) return;

    gallery.appendChild(wishlist);
  };

  moveWishlist();

  const observer = new MutationObserver(moveWishlist);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});